import React from 'react';
import { Nav, NavItem } from 'shards-react';
import NavCategoryItem from './NavCategoryItem';
import useLocales from '../../../hooks/useLocales';
import type { QaCategory } from '../../../types/qa';

interface NavCategoryProps {
  categories: QaCategory[];
  selectedCategory: string;
  onSelect: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const NavCategory = ({ categories, selectedCategory, onSelect }: NavCategoryProps): React.ReactElement => {
  const { currentLang } = useLocales();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedTab);
  // }, [selectedTab]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <Nav pills>
      {categories.length ? (
        categories
          .filter((category) => category.name[currentLang.value] !== '')
          .map((category) => <NavCategoryItem key={'category-' + category.id} category={category} active={selectedCategory === category.id} language={currentLang.value} onSelect={onSelect} />)
      ) : (
        <NavItem>No Category</NavItem>
      )}
    </Nav>
  );
};

export default NavCategory;
